import {useAuthContext, useClient, APIClient} from '../context/auth-context';
import {ScheduleSettingBody} from './types';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';

export function save(
  client: APIClient,
  companyId: string,
  data: ScheduleSettingBody,
) {
  return client.put(`attendance/company/${companyId}/schedule/setting`, {
    data,
  });
}

export function confirm(client: APIClient, companyId: string) {
  return client.put(`attendance/company/${companyId}/schedule/setting/confirm`);
}

export function useSaveMutate(actions: any) {
  const client = useClient();
  const {companyId} = useAuthContext();
  return useMutation(
    (data: ScheduleSettingBody) => save(client, companyId, data),
    {
      ...actions,
      onError: (error: {code: number; message: string}) => {
        if (error.code !== 500) {
          toast.error(error.message || '儲存失敗', {
            hideProgressBar: true,
            position: 'top-center',
            autoClose: false
          });
        }
      },
    },
  );
}

export function useConfirmMutate(actions: any) {
  const client = useClient();
  const {companyId} = useAuthContext();
  return useMutation(
    (data: ScheduleSettingBody) =>
      save(client, companyId, data).then(() => confirm(client, companyId)),
    {
      ...actions,
      onError: (error: {code: number; message: string}) => {
        if (error.code !== 500) {
          toast.error(error.message || '儲存失敗', {
            hideProgressBar: true,
            position: 'top-center',
            autoClose: false
          });
        }
      },
    },
  );
}
